module.exports = __webpack_public_path__ + "images/b7cdcfd723a050555378c6bb89e133c8.svg";